import { ChangeEventHandler, useState } from 'react';

import { MagnifyingGlassIcon, QuestionMarkIcon } from '@/components/icons/input';
import { Input } from '@/components/shared/Input/Input.tsx';
import { Tooltip } from '@/components/shared/Tooltip/Tooltip.tsx';
import { useFilterStore } from '@/store';

import cn from './styles.module.sass';

export const FavNumInput = () => {
    const { setFavNum, setSearchParams, favNum } = useFilterStore();
    const [isTooltipShown, setIsTooltipShown] = useState(false);

    const handleFavNumChange: ChangeEventHandler<HTMLInputElement> = e => {
        const isInputFilled = e.target.value.length > 0;
        setFavNum(e.target.value);
        setSearchParams({ isFree: isInputFilled, msisdnMask: e.target.value });
    };

    return (
        <div className={cn.inputWrapper}>
            {isTooltipShown && (
                <Tooltip text="Напиши свое любимое число (555), памятную дату (0905) или последовательность цифр (12345)" />
            )}
            <span className={cn.mGlassIcon}>{MagnifyingGlassIcon}</span>
            <span onClick={() => setIsTooltipShown(!isTooltipShown)} className={cn.qMarkIcon}>
                {QuestionMarkIcon}
            </span>
            <Input
                hasClearBtn={false}
                containerClassName={cn.inputContainer}
                className={cn.input}
                maskChar=""
                type="tel"
                value={favNum}
                onChange={handleFavNumChange}
                mask="99999999999"
                placeholder="Введи от 1 до 11 цифр"
            />
        </div>
    );
};
